import { render, staticRenderFns } from "./IconMediaBoth.vue?vue&type=template&id=3f8cda56"
import script from "./IconMediaBoth.vue?vue&type=script&lang=js"
export * from "./IconMediaBoth.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports